import { render } from "./CadastroFacial.vue?vue&type=template&id=4fd40eb4&scoped=true"
import script from "./CadastroFacial.vue?vue&type=script&lang=js"
export * from "./CadastroFacial.vue?vue&type=script&lang=js"

import "./CadastroFacial.vue?vue&type=style&index=0&id=4fd40eb4&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd40eb4"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QToggle,QIcon,QBtn});
